import React, { Fragment, useState } from "react";
import { useDrop } from "react-dnd";
import { Row, Col, Button } from "reactstrap";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";

import ColDisplay, { FORM_BUILDER_COL } from "./3_ColDisplay";
import ColModal from "./4_ColModal";

const ColsAttributes = (props) => {
  const {
    fields,
    fields: { name },
    column_types,
    disabled,
    canGoUp,
    canGoDown,
    moveUp,
    moveDown,
    revisionIndex,
    custom_form,
    rowIndex,
    moveCol,
    insertColAsRow,
    canDropColOnRow,
  } = props;

  const [fieldOpen, setFieldOpen] = useState({ fieldName: null, fieldIndex: null });
  const [colModalOpen, setColModalOpen] = useState(false);

  const toggleColModal = () => {
    setColModalOpen(!colModalOpen);
  };

  const filteredFields = _.filter(fields.value, (f) => !f._destroy);
  const desktopWidthTotal = _.sumBy(filteredFields, (f) => parseInt(f.desktop_width)) || 0;

  const moveLeft = (index) => {
    const toIndex = index == 0 ? fields.length - 1 : index - 1;
    fields.swap(index, toIndex);
  };

  const moveRight = (index) => {
    const toIndex = index == fields.length - 1 ? 0 : index + 1;
    fields.swap(index, toIndex);
  };

  // Drop on the row's empty space appends the col (col drop targets handle their own drops first)
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: FORM_BUILDER_COL,
      canDrop: (item) => canDropColOnRow(item, rowIndex),
      drop: (item, monitor) => {
        if (monitor.didDrop()) return;
        moveCol(item.rowIndex, item.colIndex, rowIndex, fields.length);
      },
      collect: (monitor) => ({
        isOver: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
      }),
    }),
    [rowIndex, fields.length, moveCol, canDropColOnRow]
  );

  let rowDropClass = "formBuilderRow";
  if (isOver && canDrop) rowDropClass += " formBuilderRow--over";
  if (isOver && !canDrop) rowDropClass += " formBuilderRow--reject";

  return (
    <Fragment>
      <div ref={drop} className={rowDropClass}>
        <Row>
          {fields.map((field, thisColIndex) => {
            const thisCol = fields.value[thisColIndex];
            const markedForDestruction = _.get(thisCol, "_destroy");

            const canGoRight = thisColIndex != fields.value.length - 1;
            const canGoLeft = thisColIndex != 0;

            if (!markedForDestruction) {
              return (
                <Col key={thisCol?.uid || thisColIndex} md={thisCol?.desktop_width}>
                  <ColDisplay
                    name={field}
                    column_types={column_types}
                    columnValues={thisCol}
                    openEdit={() => {
                      if (!disabled) {
                        setFieldOpen({ fieldName: field, fieldIndex: thisColIndex });
                        toggleColModal(true);
                      }
                    }}
                    disabled={disabled}
                    canGoRight={canGoRight}
                    canGoLeft={canGoLeft}
                    canGoUp={canGoUp}
                    canGoDown={canGoDown}
                    moveLeft={() => moveLeft(thisColIndex)}
                    moveRight={() => moveRight(thisColIndex)}
                    moveDown={() => moveDown(thisColIndex)}
                    moveUp={() => moveUp(thisColIndex)}
                    custom_form={custom_form}
                    rowIndex={rowIndex}
                    colIndex={thisColIndex}
                    moveCol={moveCol}
                    insertColAsRow={insertColAsRow}
                    canDropColOnRow={canDropColOnRow}
                  />
                </Col>
              );
            }
          })}
          {desktopWidthTotal < 12 && !disabled && (
            <Col>
              <Button
                onClick={() => {
                  fields.push({ uid: uuidv4(), desktop_width: 12 }); // Add a uid to make it easier to filter out, only needed on the front end.
                  setFieldOpen({
                    fieldName: `${name}[${fields.length}]`,
                    fieldIndex: fields.length,
                  });
                  toggleColModal();
                }}
              >
                Add Col
              </Button>
            </Col>
          )}
        </Row>
      </div>
      {colModalOpen && (
        <ColModal
          column_types={column_types}
          isOpen={colModalOpen}
          toggle={toggleColModal}
          fieldOpen={fieldOpen}
          fields={fields}
          revisionIndex={revisionIndex}
          {...props}
        />
      )}
    </Fragment>
  );
};

export default ColsAttributes;
